/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {
  Form,
  FormGroup,
  FormControl,
  ControlLabel,
  Col,
} from 'react-bootstrap';
import RichButton from 'loracoms/RichButton';
import FormBlock from 'loracoms/FormBlock';
import ControlTips from 'loracoms/ControlTips';
import IntlMsg from 'lorautils/intl/IntlMsg';
import ErrorSet from 'lorautils/errors/ErrorSet';
import deviceActions from 'loraactions/device';
import { isInteger } from 'lorautils/checkers/numbers';

const kTargetPatterns = [{
  pattern: /.*freq.*/i,
  target: 'freq',
}];

const guessTarget = (message) => {
  const hit = _.find(kTargetPatterns, p => p.pattern.test(message));
  if (hit) {
    return hit.target;
  }
  return 'submit';
};

const propTypes = {
  sent: React.PropTypes.object.isRequired,
  intl: React.PropTypes.any.isRequired,
  deviceId: React.PropTypes.string.isRequired,
  sendCmd: React.PropTypes.func.isRequired,
  getTxSize: React.PropTypes.func.isRequired,
  getMacLog: React.PropTypes.func.isRequired,
};

class DlChannelReq extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: (
        new ErrorSet()
          .add('FE_EMPTY', 'chindex')
          .add('FE_EMPTY', 'freq')
      ),
    };
    this.intlMsg = new IntlMsg(props.intl, 'devicedetail.macview');
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeChIndex = this.handleChangeChIndex.bind(this);
    this.handleChangeFreq = this.handleChangeFreq.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { sent } = nextProps;
    let { errors } = this.state;

    if (sent !== this.props.sent) {
      this.setState({ sentStatus: sent.status });
      if (sent.status === 'failure') {
        errors = errors.add(sent.error.code, guessTarget(sent.error.message));
        this.setState({ errors });
        _.delay(() => {
          this.setState({
            errors: this.state.errors.remove('submit'),
          });
        }, 3000);
      }
      if (sent.status === 'success') {
        const { getTxSize, getMacLog, deviceId } = nextProps;
        getTxSize(deviceId);
        getMacLog(deviceId);
      }
    }
  }

  handleChangeChIndex(e) {
    const chindex = e.target.value.trim();
    this.setState({ chindex });

    const { errors } = this.state;

    if (chindex === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'chindex') });
      return;
    }
    if (!isInteger(chindex, { min: 0, max: 15 })) {
      this.setState({ errors: errors.add('FE_INVALID', 'chindex') });
      return;
    }
    this.setState({ errors: errors.remove('chindex') });
  }

  handleChangeFreq(e) {
    const freq = e.target.value.trim();
    this.setState({ freq });

    const { errors } = this.state;

    if (freq === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'freq') });
      return;
    }
    if (!isInteger(freq)) {
      this.setState({ errors: errors.add('FE_INVALID', 'freq') });
      return;
    }
    this.setState({ errors: errors.remove('freq') });
  }

  handleSubmit(e) {
    this.setState({ submitted: true });
    e.preventDefault();

    const { errors } = this.state;
    if (!errors.isEmpty()) {
      return;
    }

    const { deviceId, sendCmd } = this.props;
    const { chindex, freq } = this.state;
    sendCmd(deviceId, { chindex, freq });
  }

  render() {
    const {
      sentStatus = '',
      chindex = '',
      freq = '',
      errors,
      submitted = false,
    } = this.state;

    return (
      <Form horizontal onSubmit={this.handleSubmit}>
        <FormGroup validationState={submitted && errors.has('chindex') ? 'error' : undefined}>
          <Col md={3}>
            <ControlLabel bsClass="aisz-control-label">ChIndex</ControlLabel>
          </Col>
          <Col md={6}>
            <FormControl
              bsClass="aisz-form-control-f"
              value={chindex}
              placeholder={this.intlMsg.msg('dlchannelreq.chindex.placeholder')}
              onChange={this.handleChangeChIndex}
            />
            <ControlTips
              show={submitted && errors.has('chindex')}
              message={this.intlMsg.errorMsg(errors.get('chindex'))}
              azStyle="danger"
            />
          </Col>
        </FormGroup>
        <FormGroup validationState={submitted && errors.has('freq') ? 'error' : undefined}>
          <Col md={3}>
            <ControlLabel bsClass="aisz-control-label">Frequency</ControlLabel>
          </Col>
          <Col md={6}>
            <FormControl
              bsClass="aisz-form-control-f"
              value={freq}
              placeholder={this.intlMsg.msg('dlchannelreq.freq.placeholder')}
              onChange={this.handleChangeFreq}
            />
            <ControlTips
              show={submitted && errors.has('freq')}
              message={this.intlMsg.errorMsg(errors.get('freq'))}
              azStyle="danger"
            />
          </Col>
        </FormGroup>
        <FormGroup>
          <Col mdOffset={3} md={6}>
            <RichButton
              status={sentStatus}
              states={[{
                status: 'default',
                label: this.intlMsg.msg('submit'),
                style: 'primary',
                type: 'submit',
              }, {
                status: 'success',
                label: this.intlMsg.msg('submit.success'),
                style: 'success',
                timer: () => this.setState({ sentStatus: '' }),
              }, {
                status: 'failure',
                label: this.intlMsg.msg('submit.failure'),
                style: 'danger',
                timer: () => this.setState({ sentStatus: '' }),
              }]}
            />
          </Col>
        </FormGroup>
        <FormGroup>
          <Col mdOffset={3} md={6}>
            <FormBlock
              show={errors.has('submit')}
              message={this.intlMsg.errorMsg(errors.get('submit'))}
              azStyle="danger"
            />
          </Col>
        </FormGroup>
      </Form>
    );
  }
}

DlChannelReq.propTypes = propTypes;

const mapStateToProps = state => ({
  sent: state.device.sendDlChannelReq,
});

const mapDispatchToProps = {
  sendCmd: deviceActions.sendDlChannelReq,
  getTxSize: deviceActions.getMacTxSize,
  getMacLog: deviceActions.getMacLog,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(DlChannelReq));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/DeviceDetail/coms/MacView/coms/DlChannelReq.jsx